RivalIQ.module('behaviors', function (behaviors, App, Backbone, Marionette, $, _) {

    'use strict';

    Marionette.Behaviors.behaviorsLookup = function () {
        return RivalIQ.behaviors;
    };
});
